import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";

const MEALS = ["Breakfast", "Lunch", "Dinner", "Snack"];

export function weekDays() {
  const days = [];
  const today = new Date();
  const monday = new Date(today);
  const dow = (today.getDay() + 6) % 7;
  monday.setDate(today.getDate() - dow);
  for (let i = 0; i < 7; i++) {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    days.push(d);
  }
  return days;
}

export function fmtDate(d) {
  return d.toISOString().slice(0, 10);
}

export default function AddToPlanDialog({ recipe, open, onClose }) {
  const days = weekDays();
  const [date, setDate] = useState(fmtDate(days[0]));
  const [meal, setMeal] = useState("Dinner");
  const [saving, setSaving] = useState(false);

  const add = async () => {
    setSaving(true);
    try {
      await api.post("/planner", { date, meal_type: meal, recipe });
      toast.success(`Added to ${meal}`);
      onClose();
    } catch (e) {
      toast.error("Could not add to plan");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-[#FBF9F5] border-[#E2D9CC] rounded-2xl" data-testid="add-to-plan-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Add to meal plan</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-[#6E6259] -mt-1">{recipe?.title}</p>

        <div className="mt-4">
          <label className="text-xs font-mono uppercase tracking-wider text-[#9C8F85]">Day</label>
          <div className="grid grid-cols-7 gap-1.5 mt-2">
            {days.map((d) => {
              const val = fmtDate(d);
              const active = val === date;
              return (
                <button
                  key={val}
                  onClick={() => setDate(val)}
                  className={`rounded-lg py-2 text-xs flex flex-col items-center transition-colors ${active ? "bg-[#C85A32] text-white" : "bg-white border border-[#E2D9CC] text-[#6E6259]"}`}
                >
                  <span>{d.toLocaleDateString("en", { weekday: "short" }).slice(0, 2)}</span>
                  <span className="font-serif text-base">{d.getDate()}</span>
                </button>
              );
            })}
          </div>
        </div>

        <div className="mt-4">
          <label className="text-xs font-mono uppercase tracking-wider text-[#9C8F85]">Meal</label>
          <div className="grid grid-cols-4 gap-1.5 mt-2">
            {MEALS.map((m) => (
              <button
                key={m}
                onClick={() => setMeal(m)}
                className={`rounded-lg py-2 text-xs transition-colors ${meal === m ? "bg-[#4A6B4E] text-white" : "bg-white border border-[#E2D9CC] text-[#6E6259]"}`}
              >
                {m}
              </button>
            ))}
          </div>
        </div>

        <Button data-testid="confirm-add-plan-btn" disabled={saving} onClick={add} className="w-full mt-5 h-11 rounded-xl bg-[#C85A32] hover:bg-[#B04B26] text-white">
          {saving ? "Adding…" : "Add to plan"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
